import React from "react";
import { Trophy } from "lucide-react";
import { formatMoney, formatMoney2, formatPct, formatNumber } from "../../lib/api";

const dec2 = (v) => (v ?? 0).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const RANKINGS = [
  { k: "facturacion", label: "Facturación", fmt: formatMoney },
  { k: "tickets", label: "Número de operaciones", fmt: formatNumber, tickets: true, sinOps: true },
  { k: "ticket_medio_solo_libre", label: "Ticket medio venta libre", fmt: formatMoney2, tickets: true },
  { k: "pct_consejo_en_receta", label: "Ratio de ventas mixtas", fmt: formatPct, tickets: true },
  { k: "ratio_productos_libre_receta", label: "Productos libres por receta", fmt: dec2, tickets: true },
  { k: "pct_parafarmacia", label: "% parafarmacia", fmt: formatPct },
  { k: "facturacion_parafarmacia", label: "Parafarmacia", fmt: formatMoney },
  { k: "ratio_consejo_para", label: "Recetas con consejo", fmt: formatPct, tickets: true },
  { k: "consejo_eur", label: "Venta de consejo", fmt: formatMoney },
  { k: "stock_parado_eur", label: "Stock D vendido", fmt: formatMoney },
];

const MEDAL = ["bg-amber-400 text-white", "bg-slate-400 text-white", "bg-orange-700 text-white"];

export const RankingEquipo = ({ rows, hasTickets, names = {} }) => {
  const base = (rows || []).filter((r) => !hasTickets || (r.tickets || 0) >= 20);
  const list = RANKINGS.filter((r) => !r.tickets || hasTickets);
  if (!base.length) return <div className="card p-8 text-center text-slate-500" data-testid="ranking-empty">No hay empleados con suficientes operaciones este mes.</div>;
  return (
    <div data-testid="ranking-equipo">
      <p className="text-xs text-slate-500 mb-4">Solo cuentan empleados con al menos 20 operaciones en el mes.</p>
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        {list.map((r) => {
          const sorted = [...base].sort((a, b) => (b[r.k] || 0) - (a[r.k] || 0));
          const max = sorted[0]?.[r.k] || 1;
          return (
            <div key={r.k} className="card p-5" data-testid={`ranking-${r.k}`}>
              <div className="flex items-center gap-2 mb-3">
                <Trophy size={15} className="text-amber-500" />
                <h3 className="font-display font-bold">{r.label}</h3>
              </div>
              <ol className="space-y-1.5">
                {sorted.map((e, i) => (
                  <li key={e.vendedor} className="text-xs" data-testid={`ranking-${r.k}-${i + 1}`}>
                    <div className="flex items-center gap-2">
                      <span className={`h-5 w-5 rounded-full flex items-center justify-center text-[10px] font-bold ${MEDAL[i] || "bg-slate-100 text-slate-600"}`}>{i + 1}</span>
                      <span className="font-semibold flex-1 truncate">{names[e.vendedor] || e.vendedor}</span>
                      <span className="font-mono">{r.fmt(e[r.k])}</span>
                      {hasTickets && !r.sinOps && <span className="font-mono text-[10px] text-slate-500 w-16 text-right" title="Número de operaciones" data-testid={`ranking-${r.k}-${i + 1}-ops`}>{formatNumber(e.tickets)} op.</span>}
                    </div>
                    <div className="ml-7 mt-0.5 h-1 rounded-full bg-slate-100 overflow-hidden">
                      <div className="h-full bg-slate-900 transition-[width] duration-700" style={{ width: `${Math.max(0, (100 * (e[r.k] || 0)) / max)}%` }} />
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          );
        })}
      </div>
    </div>
  );
};
